import VideoScreenSaver from './video-screensaver'

export default VideoScreenSaver
